// removed by extract-text-webpack-plugin
module.exports = {"sizer":"sizer-3WJJl","total":"total-2VFOp","per-page":"per-page-34B4T","perPage":"per-page-34B4T","combobox":"combobox-1MUCP"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-sizer/table-sizer.less
 ** module id = 197
 ** module chunks = 0
 **/